import Switch from '@/common/atoms/Switch'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  value: boolean
  onChange: (enabled: boolean) => void
  onBlur?: () => void
  isDisabled?: boolean
}

// Master switch of async voting. Off by default: the normal path for a
// governance tension is the meeting, the vote is a convenience.
export default function AsyncGovernanceSwitch({
  value,
  onChange,
  onBlur,
  isDisabled,
}: Props) {
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    onChange(event.target.checked)

  return (
    <Switch
      isChecked={value}
      onChange={handleChange}
      onBlur={onBlur}
      isDisabled={isDisabled}
    >
      {t('OrgEditModal.asyncGovernance')}
    </Switch>
  )
}
